import {
  StakeMaterialityReason_StakeFragment,
  useStakeMaterialityReason_StakeUpdateMutation,
} from '@/graphql/generated';
import { useToast } from '@/components/layout/Toast';
import { useState } from 'react';
import StakeMaterialityToggle from '../../../project/stakes/StakeMaterialityToggle';
import RichTextEditorTextarea from '../../../generic/form/RichTextEditorTextarea';
import { ChevronDownIcon } from '@/components/icons';
import { Loader } from '@/components/generic/Loader';
import { useTranslation } from '@/hooks/useTranslation';

export function StakeMaterialityReason({
  stake,
  readOnly = false,
}: {
  stake: StakeMaterialityReason_StakeFragment;
  readOnly?: boolean;
}) {
  const { t } = useTranslation();
  const toast = useToast();
  const [isUpdating, setIsUpdating] = useState(false);
  const [materialityReason, setMaterialityReason] = useState<string>(
    stake.materialityReason || '',
  );
  const [displayMaterialityReason, setDisplayMaterialityReason] =
    useState<boolean>(!!stake.materialityReason);
  const [editDiagnosticStakes] =
    useStakeMaterialityReason_StakeUpdateMutation();

  const saveMaterialityReason = () => {
    setIsUpdating(true);
    editDiagnosticStakes({
      variables: {
        input: {
          id: stake.id,
          materialityReason: materialityReason,
        },
      },
    })
      .then(() => {
        toast.openToastWithMessage(t('toast:stake.materiality.save.success'));
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        setIsUpdating(false);
      });
  };

  return (
    <div className="space-y-2">
      <div className="flex items-center gap-2">
        <StakeMaterialityToggle stake={stake} disabled={readOnly} />
        <h6>{t('stake.detailModal.materiality.reason.title')}</h6>
      </div>

      {!readOnly && (
        <div>
          {materialityReason !== (stake.materialityReason || '') && (
            <div className="flex justify-end">
              <button
                className="primary purple small"
                onClick={saveMaterialityReason}
                disabled={
                  isUpdating ||
                  materialityReason === (stake.materialityReason || '')
                }
              >
                {isUpdating && <Loader />}
                <div>{t('global:save')}</div>
              </button>
            </div>
          )}
          {displayMaterialityReason ? (
            <RichTextEditorTextarea
              value={materialityReason}
              placeholder={
                stake.isDisabled
                  ? t(
                      'stake.detailModal.materiality.reason.immateriality_reason',
                    )
                  : t('stake.detailModal.materiality.reason.materiality_reason')
              }
              onChange={setMaterialityReason}
            />
          ) : (
            <button
              className="unstyled small text-gray-500"
              onClick={() => setDisplayMaterialityReason(true)}
            >
              <div>
                {t('stake.detailModal.materiality.reason.add_justification')}
              </div>
              <ChevronDownIcon />
            </button>
          )}
        </div>
      )}
    </div>
  );
}
